export function dispatchEvent(eventName) {
    window.dispatchEvent(new Event(eventName));
}
//# sourceMappingURL=dispatch-event.js.map
